<template>
  <b-overlay :show="busy" rounded="sm">

    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">

            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.surname }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Code" label-for="code" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.code" placeholder="Enter code" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.code = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Description" label-for="description" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.description" placeholder="Enter description" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.description = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Supplier B/L" label-size="sm">
                      <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.blac" :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="readonly">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-row>
                      <b-col> <b-form-group label="Reason required?" label-for="reasonrequired" label-cols="12">
                          <b-form-radio-group id="reasonrequired" v-model="item.reasonrequired" :options="[
                            { text: 'Yes', value: '1' },
                            { text: 'No', value: '0' },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group>
                        </b-form-group></b-col>
                      <b-col>
                        <b-form-group label="Active?" label-for="active" label-cols="12">
                          <b-form-radio-group id="active" v-model="item.active" :options="[
                            { text: 'Yes', value: '1' },
                            { text: 'No', value: '0' },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group>
                        </b-form-group></b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Position" label-for="position" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.position" placeholder="Enter position" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.position = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>

            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>

          </b-tabs>
        </b-card-body>


        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit"
                v-if="user.permissions.includes('setup_bookingpaymentmethods.admin')">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "BookingPaymentMethodEdit",

  data() {
    return {
      busy: false,
      readonly: false,
      item: {
        id: null,
        code: null,
        description: null,
        blac: null,
        reasonrequired: null,
        active:null,
        position: null,
      },
      options: {
        title: "Booking Payment Method",
        icon: "fa fa-list",
      },
    };
  },
  watch: {
    selection() {
      this.load();
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.selection[0].id,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_bookingformspaytypes($id: String) {
              setup_bookingformspaytypes(id: $id) {
                id
                code
                description
                blac   
                reasonrequired    
                active         
                position
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.setup_bookingformspaytypes.length > 0) {
          this.item = response.data.setup_bookingformspaytypes[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_bookingformspaytypes_save(
              $rows: [setup_bookingformspaytypes_input]           
            ) {
              setup_bookingformspaytypes_save(rows: $rows) {
                id
                code
                description
                blac  
                reasonrequired         
                active    
                position           
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>